import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {ClickDisplay, MapComponent, MapTab} from '../map.component'
import {Dataset, Folder, FourdCesiumHelper, FourDService, Job, JobType, Project, Transform, TransformGroup} from '4d-mapper'
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {debounceTime, filter, flatMap, take, tap} from 'rxjs/operators';
import {combineLatest, forkJoin, Observable, of, Subject, Subscription} from 'rxjs';
import {MapService} from '../../../commons/map.service';
import {AppService} from '../../../commons/app.service';
import {BaseComponent} from '../../../commons/BaseComponent';
import {Constants} from '../../../commons/Constants';
import {AclService} from '../../../commons/acl/acl.service';
import { MapDataService } from '../../../v2/commons/map-data.service';
import { StreamDataService } from '../../../v2/commons/stream-data.service';
import { FileDataService } from '../../../v2/commons/file-data.service';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';

import * as _ from 'lodash'
import { XsIncomingDataService } from '@src/app/xs/services/data/incoming-data.service';

// const Cesium = (<any>window).Cesium;
// declare var fdm: any;

@Component({
  selector: 'processing-comp',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss']
})
export class ProcessingComponent extends BaseComponent implements OnInit, OnDestroy, MapTab {


  debug:boolean = Constants.debug_off;

  // permissions
  allowed: any = {};

  // is this loading?
  loading: boolean = false;

  states:any = [
    { label:'Open', id:'open', uid:null, items:[] },
    { label:'In queue', id:'in_queue', uid:null, items:[] },
    { label:'In processing', id:'in_processing', uid:null, items:[] },
    { label:'Success', id:'finished_success', uid:null, items:[] },
    { label:'Fail', id:'finished_failed', uid:null, items:[] },
    { label:'Aborted', id:'finished_aborted', uid:null, items:[] }
  ];



  // reference to the map
  private mapComp: MapComponent

  // registered processing plugins
  plugins:any = [];
  categories:any = null;

  currentlySelected:any = null;

  runningJobs:any = {}

  activeJobs:any = [];

  editWorkflowSelected:any = null;
  workflowJobType:any = null;

  previewState:any = 'open';
  previewStep:any = 0;
  previewPluginController:any = null;
  pluginCache:boolean = false;

  languageJSON:any = {};


  constructor
  (private route: ActivatedRoute, 
    public router: Router, 
    private fourD: FourDService,
    public incomingData: XsIncomingDataService,
    snackBar: MatSnackBar, 
    dialog: MatDialog, 
    public mapService: MapService,
    public uiManager: UiManagerService,
    public permissions: AclService, public service: AppService, private dataService:MapDataService, private file:FileDataService ) {
    super(router, snackBar, dialog)

    // never initialize in the constructor
    // this.cesiumHelper = mapService.helper;
  }

  init() {
    this.fourD.onActiveAccountReady().subscribe(s => {

      /* disabled, possibly remove 
      // access control changes
      this.permissions.updatedAccess$.subscribe(tmp => {
        if ( this.debug ) { console.log ( 'main subscribed event access control' );}
        this.permissionsChanged();
      });
      */

      this.dataService.sceneJobs.state.pipe(filter(a => !!a), take(1)).subscribe(jobs => {

        this.fourD.jobTypes.filter(j => j.pluginType && <any>j.pluginType != '').forEach(j => {
          
          let item = { 
            id: '' + j.id, 
            uid: '' + j['uid'],
            name: j.name, 
            icon: j.icon, 
            category: j.category, 
            mode:'job', 
            jobTypeRef:j,
            items:jobs.filter(jj => jj.jobType == j) 
          };
          this.plugins.push (item);
          // console.log ( ' @@ job', item );
        });

      });
      
      this._subs.push(this.file.processingItems.state.subscribe(proc =>  {
          this.runningJobs = {}
          proc.forEach(element => {
            if(element.task instanceof Job)
              this.runningJobs['' + element.task.id] = true
          })
        }))

      // inject incoming job types into the plguins
      this._subs.push(this.dataService.sceneJobs.events.subscribe(j => {
        if(j.event == 'ADD'){
          // console.log ( ' @@ job ADD', j );
          this.activeJobs.push(j.item);
          var node = this.plugins.find(p => p.mode == 'job' && p.id == '' + j.item.jobType.id)
          if(node)
            node.items.push(j.item)
        }
        else  if(j.event == 'REMOVE'){
          // console.log ( ' @@ job REMOVE', j );
          var node = this.plugins.find(p => p.mode == 'job' && p.id == '' + j.item.jobType.id)
          if(node)
            node.items = node.items.filter(i => i != j.item)
        }
        else if(j.event == 'UPDATE' && j.item.status == 'finished'){
          // console.log ( ' @@ job UPDATE', j );
          var node = this.plugins.find(p => p.mode == 'job' && p.id == '' + j.item.jobType.id)
          node.items = node.items.filter(i => i != j.item)
        }
      }))
      
      this.fourD.transformTypes.filter(j => j.pluginType && (<any>j).pluginType != '').forEach(j => {
        // console.log ( ' @@ transform ADD', j );

        if ( this.permissions.can)
        this.plugins.push ({ id: '' + j.id, name: j.name, icon: j.icon, category: j.category, mode:'transform' })
      })
    
      // crete our categories, with sub-jobs/transforms underneath
      this.categories = new Map();
      this.plugins.map ( p => {
        if ( ! this.categories.has (p.category) ) {
          this.categories.set( p.category, {} );
        }
        let category = this.categories.get(p.category);
        category[p.id] = p;
        this.categories.set(p.category, category ) ;
      });

    })
    
    this.previewPluginController = {
      id: 999,
      meta: {
        category: 'preview'
      },
      hideDelete: true,
      hideHeader: true,
      item: null,
      controller: null,
      controls: [],
      getLabel: function () { return 'preview' },
      refresh: function () {},
      save: function () {},
      has: function () { return false },
      linearScale: function () {},

      goto: function ( p ) {
        // console.log('goto() !!!!!!!!!!!', p);
      },
      show: function ( p ) {
        // console.log('show() !!!!!!!!!!!', p);
      },
      hide: function ( p ) {
        // console.log('hide() !!!!!!!!!!!', p);
      },
    };
  
  }

  slugify ( text ) {
    return text
    .toString()
    .normalize( 'NFD' )                   // split an accented letter in the base letter and the acent
    .replace( /[\u0300-\u036f]/g, '' )   // remove all previously split accents
    .toUpperCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '_'); 
  };

  populatePluginController( items ) {

    if ( !this.pluginCache ) {
      let these = [];
      items.forEach(i => {
        let a = _.cloneDeep(i);
        let t = '';
        if ( i && i.label_token ) {
          t = i.label_token;
        }
        a.name = this.slugify ( t );
        these.push(a);
      });
      this.previewPluginController.controls = these;
      this.createLanguageJSON();
      this.pluginCache = true;
    }

    return true;
  }

  createLanguageJSON() {

    let res = {};

    if ( this.editWorkflowSelected ) {

      let uid = ('' + this.editWorkflowSelected.uid).toUpperCase();

      res[uid] = {};

      if ( this.editWorkflowSelected['worflow-template'] ) {
        this.editWorkflowSelected['worflow-template'].forEach ( step => {
          
          let stepIdx = 'STEP_'+(step.step + 1);
          res[uid][stepIdx] = {};

          step.states.forEach ( state => {
            state.items.forEach ( item => {
              let content = '';
              if ( item.value ) {
                content = item.value;
              } 
              if ( item.label_token ) {
                res[uid][stepIdx][this.slugify(item.label_token)] = '';
              }
              if ( item.text_token ) {
                res[uid][stepIdx][this.slugify(item.text_token)] = content;
              }
            });
            
          });
        });
      }
    }

    this.languageJSON = res;

    
    /*
    <ng-container *ngFor="let step of editWorkflowSelected['worflow-template']">

                  <div><b>{{ step.label_token }}</b></div>

                  <ng-container *ngFor="let state of step.states">
                      <ng-container *ngFor="let item of state.items">
                        <div *ngIf="item.label_token">{{ step.label_token + '.' + item.label_token.toUpperCase() }}</div>
                        <div *ngIf="item.text_token">{{ step.label_token + '.' + item.text_token.toUpperCase() }}</div>
                      </ng-container>
                  </ng-container>

                </ng-container>
                */
  }

  editWorkflow ( job:any = null ) {

    this.workflowJobType = job.jobTypeRef;
    this.editWorkflowSelected = this.workflowJobType.baseTransform;
    // console.log('@@@ editWorkflow()', this.workflowJobType, this.editWorkflowSelected );
  }

  saveWorkflow( steps:any = null ) {
    if ( this.editWorkflowSelected ) {
      this.editWorkflowSelected['worflow-template'] = _.cloneDeep(steps);
      console.log('@@@ saveWorkflow()', steps );
      this.editWorkflowSelected.saveObservable().subscribe( done => {
        console.log('@@@ saveWorkflow() SAVED', this.editWorkflowSelected, done );
      });
    }
  }


  clickedMap(movement, rightClick: boolean, checkedPosition): ClickDisplay {
    
    return ClickDisplay.None;
  }

  
  becameActive(mapComp: MapComponent) {

    // if ( this.debug ) { console.log ( 'processing.comp :: becameActive()' ); }

    if ( this.mapService.scene ) {
      this.incomingData.populateFromScene(this.mapService.scene);
    }
    

    this.mapComp = mapComp;

    /*
    if (this.mapService.scene) { // get list of datasets which user can tile from layers.
      if (this.mapService.scene.folder) {
        this.mapComp.fetchDatasetForManualTiling(this.mapService.scene.folder);
      } else {
        this.mapService.scene.fetchObservable().subscribe(_ => {
          // TODO : there's a bug here where scene can be null, but I don't know exactly what this code is trying to do (@haresh)
          if (this.mapService.scene.folder) {
            this.mapComp.fetchDatasetForManualTiling(this.mapService.scene.folder);
          }
        });
      }
    }
    */
  }

  becameInactive(mapComp: MapComponent) {
  }

}

